import { createAsyncThunk } from '@reduxjs/toolkit';
import { ROLLBACK_LIST_API_URL } from '@custom/constant';
import { RollbackListArgs } from '@custom/Utils/constants/interfaces';

// Async thunk for fetching rollback list
export const fetchRollbackList = createAsyncThunk(
  'report/fetchRollbackList',
  async ({ limit, pageNumber, search }: RollbackListArgs, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const response = await fetch(ROLLBACK_LIST_API_URL, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          limit: limit,
          pageNumber: pageNumber,
          search: search || '', // Ensure search is a string
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to fetch rollback report list');
      }

      return await response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export default fetchRollbackList;
